// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import { ModalBody } from '@/common-utils/components/ui/modal';
import { Card } from '@/common-utils/components/ui/card';
import CardDeck from '@/common-utils/components/renders/cardDeck/CardDeck';
// Common
import EXTERNAL_CONTRACT_TYPES from '../../../../../enums/externalContractType';
// Css
import './BodySelectPaymentMethod.scss';

/**
 * @param {function} getSelectedExternalContract
 * @returns {JSX} BodySelectPaymentMethod
 */
function BodySelectPaymentMethod({ getSelectedExternalContract }) {
    // Constants
    const externalContracts = [... new Set(
        Object.keys(EXTERNAL_CONTRACT_TYPES)
            .filter(contractKey => contractKey !== 'DEFAULT')
            .map(contractKey => ({ type: EXTERNAL_CONTRACT_TYPES[contractKey] }))
    )];

    // State - use the contract type name for selection
    const [selectedContractName, setSelectedContractName] = useState(EXTERNAL_CONTRACT_TYPES.DEFAULT.name);

    // Hooks
    useEffect(() => {
        getSelectedExternalContract({ type: EXTERNAL_CONTRACT_TYPES.DEFAULT });
    }, []);

    // Functions
    const sendData = (extContract) => {
        setSelectedContractName(extContract.type.name);
        getSelectedExternalContract(extContract);
    };

    const setExternalContractLogoOrName = (extContract) => {
        if (extContract.type.logo) {
            return <p className='card-text'>
                <img alt='' className='small-img-card' src={extContract.type.logo}></img>
            </p>;
        } else {
            return <div>{extContract.type.name}</div>;
        }
    };

    const buildExternalContract = (extContract) => {
        if (!extContract.type) {
            return null;
        } else {
            const isSelected = selectedContractName === extContract.type.name;
            return (
                <Card
                    key={extContract.key}
                    center
                    onClick={() => sendData(extContract)}
                    className={cn(
                        'card card-clickable cursor-pointer transition-all duration-200',
                        isSelected
                            ? 'bg-gray-50 shadow-[0_0_2px_black]'
                            : 'bg-white hover:bg-gray-50 hover:shadow-md hover:-translate-y-1'
                    )}
                    dataCy={extContract.type.name}>
                    {
                        setExternalContractLogoOrName(extContract)
                    }
                </Card>
            );
        }
    };

    return (
        <ModalBody className='selection-payment-method'>
            <CardDeck
                cardsProps={externalContracts}
                component={buildExternalContract}
                cardsNumberPerRow={3}
            />
        </ModalBody>
    );
}

BodySelectPaymentMethod.propTypes = {
    getSelectedExternalContract: PropTypes.func.isRequired
};

export default BodySelectPaymentMethod;